const technologies = [
  { name: "React", devicon: "devicon-react-original colored" },
  { name: "PHP", devicon: "devicon-php-plain colored" },
  { name: "jQuery", devicon: "devicon-jquery-plain colored" },
  { name: "Bootstrap", devicon: "devicon-bootstrap-plain colored" },
  { name: "HTML5", devicon: "devicon-html5-plain colored" },
  { name: "CSS3", devicon: "devicon-css3-plain colored" },
  { name: "JavaScript", devicon: "devicon-javascript-plain colored" },
  { name: ".NET", devicon: "devicon-dot-net-plain-wordmark colored" },
  { name: "Laravel", devicon: "devicon-laravel-plain colored" },
  { name: "MySQL", devicon: "devicon-mysql-plain colored" },
  { name: "Node.js", devicon: "devicon-nodejs-plain colored" },
  { name: "Flutter", devicon: "devicon-flutter-plain colored" },
];

export default technologies;
